import { TApplicationState } from '../types/redux';

export const selectQueryString = (state: TApplicationState) => state.page.queryString || {};

export const selectIsStickyScrollBtnVisible = (state: TApplicationState) => state.page.stickyScrollBtnVisible;

export const selectIsModalOpen = (state: TApplicationState) => state.page.modal.modalFormOpen;

export const selectModalSource = (state: TApplicationState) => state.page.modal.modalSource;
